import { useVacancyQuery } from "@generated/graphql";
import { Stack, Typography } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useParams } from "react-router-dom";

const Header = () => {
  const { vacancyId } = useParams();
  const isCreate = useIsCreate();
  const { data } = useVacancyQuery({ variables: { vacancyId: vacancyId! } });

  const vacancy = data?.vacancy;

  const getCandidateTopic = () => {
    if (isCreate) return "";

    return [vacancy?.numericId || "", vacancy?.title || ""].filter((item) => item).join(", ");
  };

  const title = `Вакансия ${getCandidateTopic()}`;

  useSetTabTitle(title, vacancy);

  return (
    <Stack
      direction='row'
      alignItems='flex-start'
      spacing={2}>
      <Typography variant='h28'>{title}</Typography>
    </Stack>
  );
};

export default Header;
